import { IconButton, TableRow } from '@mui/material';
import { Box } from '@mui/system';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const SideTableContainer = styled(Box)`
  && {
    margin-top: 6.25rem;
    margin-bottom: 0.75rem;
    padding-left: 1rem;
    min-height: 280px;
  }
`;

export const InvoicesTableRow = styled(TableRow)<{
  $deleted?: boolean;
  $marked?: boolean;
  $highlighted?: boolean;
}>`
  ${({ $deleted }) =>
    $deleted &&
    `{
    text-decoration: line-through;
    background-color: ${COLORS.GRAY_1};
    }`}
  ${({ $highlighted }) =>
    $highlighted &&
    `{
    background-color: #c4dbff;
    &&.MuiTableRow-hover:not(.Mui-selected) {
      &:hover {
        background-color: #b0cfff;
      }
    }
    }`}
  ${({ $marked }) =>
    $marked &&
    `{
    background-color: ${COLORS.RED};
    &&.MuiTableRow-hover:not(.Mui-selected) {
      &:hover {
        background-color: ${COLORS.DARK_RED};
      }
    }
    }`}
`;

export const ToolbarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

export const ResizeButton = styled(IconButton)`
  && {
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 4px;
    padding: 2px;
    height: 100%;
  }
`;

export const ActionsContainer = styled.div`
  margin-top: 0.75rem;
  width: 200px;
  display: flex;
  gap: 0.5rem;
`;
